import { render, staticRenderFns } from "./teamRebates.vue?vue&type=template&id=67ce2bfb&scoped=true"
import script from "./teamRebates.vue?vue&type=script&lang=js"
export * from "./teamRebates.vue?vue&type=script&lang=js"
import style0 from "./teamRebates.vue?vue&type=style&index=0&id=67ce2bfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce2bfb",
  null
  
)

export default component.exports